export const routes = {
  login: "/signin",
  admin: {
    signin: "/admin_signin",
    forgetPassword: "/admin_forget_password",
    resetPassword: "/admin_reset_password",
    root: "/admin",
    child: {
      config: "configuration-and-settings",
      coupon: "order-email-and-coupon-settings",
      users: "user-details",
      orders: "all-users-orders",
      blog: "blog-post-posting",
      services: "auto-services",
      ip: "ip_configuration",
      notice: "notice_area",
      affiliate: "affiliate",
    },
  },
};
